function manageError() {
  var allSelected = true;
    if($('#currproduct-type[value*="Bra"]').length){
      $('.product__color-chips:not(.chips2-wrap)').each(function(){
        if ($(this).find('.product__chip.selected').length === 0) {
          allSelected = false; return false;
        }
      });
    }
    else{
      $('.product__color-chips').each(function(){
        if ($(this).find('.product__chip.selected').length === 0) {
          allSelected = false; return false;
        }
      });
    }

    if(allSelected){
      $('.product-form__cart-submit').removeAttr('disabled').removeAttr('title');
    } else {
      $('.product-form__cart-submit').attr('disabled', 'disabled').attr('title', 'Please select an option from every group');
    }

    if($('.product__chip.selected').length == 0){
      $('[no-size-error]').show();
    }else{
      if($('[no-size-error]').length && $('[data-band-error]').length && $('[data-cup-error]').length){
        $('.product-form__cart-submit').removeAttr('disabled').removeAttr('title');
      }
      $('[no-size-error]').hide();
    }
}

jQuery(document).ready(function ($) {
  $('.fs-product-card-title').matchHeight();
  if ($('.flair-badge').length > 0) {
    $('.flair-badge-layout').matchHeight();
    $('.fs-product-card-title').matchHeight();
  }

  function checkSelected() {
    if($('.product__details').length){

      var productType = $('.product__meta #currproduct-type').val().toLowerCase().replace(' ', '_');
      var selectedSwatch = localStorage.getItem(productType);
      if(selectedSwatch != '' && selectedSwatch != undefined && selectedSwatch != null){
        var selection = JSON.parse(selectedSwatch);
        $.each(selection, function(key, value) {
          var $chip = $('.product__chip[data-type="' + key + '"][data-value="' + value + '"]:not(.disabled)');
          if ($chip.length) { $chip.trigger('click'); }
        });
      }
      
      manageError();
      $('.product__chip.selected').trigger('click');
    }
  }

  checkSelected();
});

$(document).on('click', '.product__chip:not(.disabled)', function(){
  if($('.product__chip.selected').length == 0){
    $('[no-size-error]').show();
  }else{
    $('[no-size-error]').hide();
  }

  $('.adding-swatch-color .product__color-swatch.selected').trigger('click');
  var optionType = $(this).data('type');    
  var optionValue = $(this).data('value');
  var productType = $('#currproduct-type').val().toLowerCase();
  var storageKey = productType.replace(' ', '_');
  
  if(productType.includes('bra')) {
    var braOptions = localStorage.getItem(storageKey);
    braOptions = braOptions ? JSON.parse(braOptions) : {};
    if(optionType === 'band') {
      braOptions['band'] = optionValue;
    } else if(optionType === 'cup') {
      braOptions['cup'] = optionValue;
    }
    localStorage.setItem(storageKey, JSON.stringify(braOptions));
  } else {
    var options = {};
    options[optionType] = optionValue;
    localStorage.setItem(storageKey, JSON.stringify(options));
  }

  manageError();
  
});

jQuery(document).ready(function($) {
  enableSwatchSlide();
  $(document).on('click', '.product-swatches-options__item', function(e) {
    e.preventDefault();
    const $swatch = $(this);
    $swatch.siblings().removeClass('active-swatch-item');
    $swatch.addClass('active-swatch-item');
    const variantId = +$swatch.data('variation-id');
    const $productItem = $swatch.closest('.product-item');
    const productUrl = $swatch.data('swatch-url');
    
    if (!productUrl) return;
    
    $.getJSON(productUrl + '.js', function(product) {
      const variant = product.variants.find(v => v.id === variantId);
      if (variant) {
        var nextImgPosition = 0;
        if (variant.featured_image) {
          var newImgSrc = variant.featured_image.src;
          nextImgPosition = variant.featured_image.position + 1;
          $productItem.find('.product-item__image.product-item__image--one').html(`<img src="${newImgSrc}" class="image_img">`);
        }
        var productImages = product.media;
        productImages.forEach(function(item) {
          if(item.position == nextImgPosition){
            $productItem.find('.product-item__image.product-item__image--two').html(`<img src="${item.src}" class="image_img">`);
          }
        });
        var formattedPrice = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
          ? Shopify.formatMoney(variant.price, Shopify.money_format)
          : '$' + (variant.price / 100).toFixed(2);
        $productItem.find('.product-item__price > .sale').text(formattedPrice);
        var newProductLink = productUrl + '?variant=' + variant.id;
        $productItem.find('a').attr('href', newProductLink);
      }
      else{
        var nextImgPosition = 0;
        if (product.featured_image) {
          var newImgSrc = product.featured_image;
          nextImgPosition = 2;
          $productItem.find('.product-item__image.product-item__image--one').html(`<img src="${newImgSrc}" class="image_img">`);
        }
        var productImages = product.media;
        productImages.forEach(function(item) {
          if(item.position == nextImgPosition){
            $productItem.find('.product-item__image.product-item__image--two').html(`<img src="${item.src}" class="image_img">`);
          }
        });
        var formattedPrice = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
          ? Shopify.formatMoney(product.price, Shopify.money_format)
          : '$' + (product.price / 100).toFixed(2);
        $productItem.find('.product-item__price > .sale').text(formattedPrice);
        var newProductLink = productUrl;
        $productItem.find('a').attr('href', newProductLink);
      }
    });
  });

  var popupTimeout;
  var currentSwatch = null;
  var currentPopup = null;
  
  function updatePopupPosition() {
    if (currentSwatch && currentPopup && currentPopup.is(':visible')) {
      var rect = currentSwatch[0].getBoundingClientRect();
      currentPopup.css({
        left: rect.left,
        top: rect.top - 10 
      });
    }
  }
  
  $('.product__color-swatch').on('mouseenter', function () {
    clearTimeout(popupTimeout);
  
    var $swatch = $(this);
    var optionHandle = $swatch.attr('data-option-handle');
  
    $('.color-swatchnum-popup').stop(true, true).fadeOut();
  
    var $popup = $('.color-swatchnum-popup').filter(function () {
      var colorName = $(this).attr('data-color-name');
      return optionHandle && colorName && optionHandle.indexOf(colorName) !== -1;
    }).first();
  
    if ($popup.length) {
      var rect = $swatch[0].getBoundingClientRect();
  
      $popup.find('.color-swatchnum-color-preview').css('background', $swatch.css('background'));
  
      $popup.css({
        position: 'fixed',
        left: rect.left,
        top: rect.top - 10
      }).stop(true, true).fadeIn();
  
      currentSwatch = $swatch;
      currentPopup = $popup;
    }
  });
  
  $('.product__color-swatch, .color-swatchnum-popup').on('mouseleave', function () {
    popupTimeout = setTimeout(function () {
      $('.color-swatchnum-popup').fadeOut();
      currentSwatch = null;
      currentPopup = null;
    }, 150);
  });
  
  $('.color-swatchnum-popup').on('mouseenter', function () {
    clearTimeout(popupTimeout);
  });
  
  $(window).on('scroll', function () {
    updatePopupPosition();
  });

});

function enableSwatchSlide(){
  const swiper = new Swiper('.product-swatches__wrap.swiper', {
    slidesPerView: "auto",
    grabCursor: true,
    mousewheel: true,
    freeMode: true,
    spaceBetween: 8,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const triggerContainer = document.querySelector('.collection__infinite-trigger');

  if (!triggerContainer) return;

  const link = triggerContainer.querySelector('a');
  if (!link) return;

  let clicked = false;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;

    const scrollPercent = (scrollTop + winHeight) / docHeight;

    if (scrollPercent > 0.75) {
      link.click();
    }
  });
});